export default __webpack_public_path__ + "static/media/maximum_bet_500$.8b7c32bb.mp3";